<form
  [formGroup]="form"
  (ngSubmit)="confirm()"
  class="flex flex-col">
  <div class="flex flex-col">
    <div class="flex w-full justify-between gap-4 py-4 border-b border-neutral-300">
      <span class="text-[18px] font-black">
        <i
          class="pi pi-file-edit"
          style="font-size: 2rem"></i>
        SUBSANACION DE DESPLIEGUE DE SISTEMA
      </span>
      <div class="flex gap-4">
        <app-buttons
          [label]="'Detalle de subsanación'"
          (click)="goToSummary()" />
        <app-buttons
          [label]="'Volver al paso anterior'"
          (click)="backPage()" />
        <app-buttons
          [label]="'Enviar a aprobación'"
          [disabled]="form.invalid || hasPendingObservedFields()"
          [classes]="'bg-primary-base text-primary-light disabled:bg-primary-base disabled:opacity-75'"
          (click)="confirm()"
          type="button" />
      </div>
    </div>

    <div class="flex flex-col py-4">
      <span class="font-regular text-[18px]">Paso 6 de 6</span>
      <h2 class="font-bold text-[24px] pb-6">Datos económicos</h2>

      <h3 class="font-bold text-[18px] pb-6">Impacto económico</h3>

      <div class="grid grid-cols-2">
        <div class="flex flex-col relative">
          <app-observed-field-alert
            *ngIf="isObserved('costBenefitAnalysis')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-select
            formControlName="costBenefitAnalysis"
            classes="min-w-full">
            <desy-label [ngClass]="{ 'relative -top-4': isObserved('costBenefitAnalysis') }">
              Análisis coste-beneficio*
            </desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay un análisis coste-beneficio
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'costBenefitAnalysis', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
          <ng-container *ngIf="!costBenefitExtraFilled() && costBenefitRequired()">
            <desy-error-message class="block font-semibold">
              Rellena obligatoriamente uno de los dos campos siguientes:
            </desy-error-message>
          </ng-container>
        </div>
      </div>
      <ng-container *ngIf="costBenefitRequired()">
        <div class="grid grid-cols-2 mt-4">
          <div class="flex flex-col relative">
            <span
              class="text-[14px] text-neutral-dark"
              [ngClass]="{ 'relative -top-4': isObserved('costBenefitAnalysisCsv') }">Con CSV (Código identificador del documento)</span>
            <app-observed-field-alert
              *ngIf="isObserved('costBenefitAnalysisCsv')"
              class="absolute top-2 left-0"></app-observed-field-alert>
            <desy-input
              id="costBenefitAnalysisCsv"
              [classes]="'w-full'"
              [placeholder]="'Validación 1, validación 2...'"
              formControlName="costBenefitAnalysisCsv"></desy-input>
          </div>
        </div>
        <div class="flex flex-col relative">
          <span
            class="text-[14px] text-neutral-dark block"
            [ngClass]="{ 'relative -top-4': isObserved('costBenefitAnalysisDescription') }">
            Descripción
          </span>
          <app-observed-field-alert
            *ngIf="isObserved('costBenefitAnalysisDescription')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-textarea
            id="costBenefitAnalysisDescription"
            [classes]="'w-full'"
            [placeholder]="'Describe aquí la validación contra controles ISO 42001'"
            formControlName="costBenefitAnalysisDescription"
            [rows]="3"
            [maxlength]="500"></desy-textarea>
          <span class="text-[14px] text-neutral-dark info-message block">Puedes escribir hasta 500 caracteres</span>
        </div>
      </ng-container>

      <h2 class="font-bold text-[24px] pb-6 pt-6">Impacto y evaluación</h2>

      <h3 class="font-bold text-[18px] pb-6">Valor público</h3>

      <div class="grid grid-cols-2">
        <div class="mr-6 flex flex-col relative">
          <app-observed-field-alert
            *ngIf="isObserved('publicValue')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-select
            formControlName="publicValue"
            classes="min-w-full">
            <desy-label [ngClass]="{ 'relative -top-4': isObserved('publicValue') }">Medición de valor público</desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay medición
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'publicValue', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>

      <ng-container *ngIf="publicValueRequired()">
        <div class="flex flex-col -mt-4 mb-4 relative">
          <desy-label [ngClass]="{ 'relative -top-4': isObserved('publicValueDescription') }">Descripción*</desy-label>
          <app-observed-field-alert
            *ngIf="isObserved('publicValueDescription')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <desy-textarea
            id="publicValueDescription"
            [classes]="'w-full'"
            [placeholder]="'Describe aquí la medición del valor público del sistema de IA'"
            formControlName="publicValueDescription"
            [rows]="3"
            [maxlength]="500"></desy-textarea>
          <ng-container
            *ngIf="getError(form, 'publicValueDescription', formSubmitted()) as error; else publicValueDescriptionInfo">
            <desy-error-message>
              {{ error }}
            </desy-error-message>
          </ng-container>
          <ng-template #publicValueDescriptionInfo>
            <span class="text-[14px] text-neutral-dark info-message block">Puedes escribir hasta 500 caracteres</span>
          </ng-template>
        </div>
      </ng-container>
    </div>
  </div>
</form>
